import { useRecordContext } from 'react-admin';
import { MoneyField } from '@components';
import { PricesUpdateModal } from './PricesUpdateModal';

type PricesFieldProps = {
  source?: string;
  label?: string;
};

export const PricesField = (props: PricesFieldProps) => {
  const record = useRecordContext(props);
  if (!record) {
    return null;
  }

  return (
    <div onClick={e => void e.stopPropagation()}>
      <div>
        <MoneyField source='price' />
      </div>
      <PricesUpdateModal
        productId={+record.id}
        price={record?.price}
      />
    </div>
  );
};
